const accessGrn = {

    GRN_MASTER_LIST: {
        path: '/grn-list'
    },

    ADD_GRN_MASTER: {
        path: '/add-grn'
    },

    UPDATE_GRN_MASTER: {
        path: '/edit-grn'
    },

}

export default accessGrn;
